@if (data$ | async; as data) {
  <app-alerts />

  <app-admin-shipping-settings-form
    [data]="data"
    (submitClickEvent)="handleSubmitClick($event)" />
} @else {
  <app-spinner-filled />
}
